import { Button, Field, Heading } from '@gassan-ui'
import { getUrlSlugInLocale } from '@lib/get-url-slug-in-locale'
import { Form, Formik } from 'formik'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC } from 'react'

const NewsletterSignup: FC = () => {
  const router = useRouter()
  const {
    t,
    i18n: { language },
  } = useTranslation(['footer', 'forms', 'other'])

  return (
    <Formik
      initialValues={{ email: '' }}
      onSubmit={async (values) => {
        router.push({
          pathname: `/${language}/${getUrlSlugInLocale('newsletter', language)}`,
          query: { email: values.email },
        })
      }}
    >
      <Form>
        <Heading variant="h4" as="h4" className="mb-2 sm:mb-4">
          {t('stayUpdated', { ns: 'footer' })}
        </Heading>
        <Field
          type="email"
          field="input"
          id="signup-email"
          name="email"
          label={t('labels.email', { ns: 'forms' })}
        />
        <Button variant="dark" type="submit" style={{ width: '100%' }}>
          {t('signup', { ns: 'other' })}
        </Button>
      </Form>
    </Formik>
  )
}

export default NewsletterSignup
